export class DetalhesAssinaturaResponse {
  descricao: string;
  produto: string;
  trialGratuito: boolean;
  tempoAvaliacaoGratuita: number;
  diasRestantesAvaliacao: number;
  diasTesteUtilizados: number;
}
